import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage/HomePage';
import CommunityDevelopment from './pages/CommunityDevelopment/CommunityDevelopment';
import { initializeDynamicColors } from './utils/dynamicColors';
import './styles/global.css';
import './components/chatbot/FontOverride.css';

const App: React.FC = () => {
  useEffect(() => {
    // Initialize dynamic colors based on URL parameters
    initializeDynamicColors();
  }, []);

  return (
    <Provider store={store}>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/community-development" element={<CommunityDevelopment />} />
            <Route path="*" element={<div className="container py-5"><h1>Page Not Found</h1></div>} />
          </Routes>
        </Layout>
      </Router>
    </Provider>
  );
};

export default App;
